module.exports = __webpack_public_path__ + "assets/img/premix-tank-with-wind-walls-folded-down.d9afcde4.jpg";